import { ALIGN_CLASSES as c, DEFAULT_ALIGNMENT as f, ALIGN_CLASSES_INVERSE as l } from "../../constants.js";
import { defineAttrs as A } from "../../utils/typed-attrs.js";
const g = A({
  alignment: { default: f }
});
function E(r) {
  r.attrs = Object.assign({}, r.attrs, g), r.parseDOM?.forEach(function(e) {
    const n = e.getAttrs;
    e.getAttrs = (t) => {
      let s;
      const o = {};
      return n && Object.assign(o, n(t)), t.classList.forEach((a) => {
        a in l && (s = l[a]);
      }), s && Object.assign(o, { alignment: s }), o;
    };
  });
  const i = r.toDOM;
  return r.toDOM = (e) => {
    const n = e.attrs;
    if (!i)
      throw new Error("must specify a toDOM method");
    const t = i(e);
    if (!Array.isArray(t) || t.length < 2)
      throw new Error("must specify at least two elements in output spec");
    t[1] === 0 && t.splice(1, 0, {});
    const s = t[1];
    return s?.class && typeof s.class == "string" ? s.class += ` ${c[n.alignment]}` : s.class = c[n.alignment], t;
  }, r;
}
export {
  E as centerable,
  g as centerableAttrs
};
